/* eslint-disable no-unused-expressions */
import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import CircularProgress from '@material-ui/core/CircularProgress'
import Moment from 'react-moment'

import Thumbnail from '../widgets/Thumbnail'
import SOVColors from '../../constants/colors'

import './DashboardComponent.scss'
import { DISTRIBUTION, HBO, HBO_AND_HBO_MAX, HBO_MAX, LINEAR, MULTICHANNEL, MULTIPLE, OTHER, STREAMIMG_NETWORKS, STREAMING, THEATRICAL_RELEASE, SOV_MEDIA_COMPANY_ALL_NETWORK, MEDIA_COMPANY_COLON, MEDIA_COMPANY_OTHERS, MEDIA_COMPANY_DISNEY, MEDIA_COMPANY_HULU, MEDIA_COMPANY_AMAZON, MEDIA_COMPANY_MGM, MEDIA_COMPANY } from '../../constants/sov'

export default class ContentRankTable extends React.Component {
  static propTypes = {
    sovContentRank: PropTypes.object,
    sovContentRankByScore: PropTypes.object,
    selectedCategory: PropTypes.string,
    selectedNetwork: PropTypes.array,
    dateArray: PropTypes.array,
    dateIndex: PropTypes.number
  }

  constructor (props) {
    super(props)

    this.state = {
      searchText: ''
    }
    this.searchRef = React.createRef()
  }

  componentDidMount () {
    if (this.state.searchText.length > 0) {
      this.searchRef.current.focus()
    }
  }

  componentDidUpdate () {
    if (this.state.searchText.length > 0) {
      this.searchRef.current.focus()
    }
  }

  onSearchTextChange = (e) => {
    this.setState({ searchText: e.target.value })
    this.searchRef.current.focus()
  }

  getLabel = (networks, labels) => {
    if (this.props.selectedCategory === STREAMING) {
      const streamingNetworks = STREAMIMG_NETWORKS.split(',')
      return networks && networks.find(l => streamingNetworks.indexOf(l) > -1)
    } else if (this.props.selectedCategory === DISTRIBUTION) {
      return labels && labels.find(l => l === STREAMING) ? STREAMING : labels && labels.find(l => l === LINEAR) ? LINEAR : ''
    } else if (this.props.selectedCategory === MEDIA_COMPANY) {
      const lbls = labels && labels.filter(l => l.indexOf(MEDIA_COMPANY_COLON) > -1)
      return lbls.length > 0 ? lbls.length[0] : ''
    }
  }

  getDisplayLabel = (network, label) => {
    if (network !== STREAMING && network !== LINEAR && network !== OTHER) {
      let displayLabel = network ? [...network] : []

      if (label?.includes(MULTICHANNEL)) {
        displayLabel.push(MULTIPLE)
      }

      return displayLabel.length > 2
        ? MULTIPLE
        : displayLabel.length === 2
        ? displayLabel.join(', ')
        : displayLabel
    }

    return label
  }

  getNetworklabel = (network) => {
    return network && network.length > 0 ? network : []
  }

  render () {
    const { sovContentRank, sovContentRankByScore } = this.props
    let details = sovContentRank?.details || []
    let detailsByScore = sovContentRankByScore?.details || []
    let { selectedNetwork } = this.props
    if (selectedNetwork.find(n => n === HBO_AND_HBO_MAX)) {
      selectedNetwork = selectedNetwork.filter(n => n !== HBO_AND_HBO_MAX)
      selectedNetwork.push(HBO)
      selectedNetwork.push(HBO_MAX)
    }
    if (selectedNetwork.find(n => n === MEDIA_COMPANY_DISNEY)) {
      selectedNetwork.push(MEDIA_COMPANY_HULU)
    } else if (selectedNetwork.find(n => n === MEDIA_COMPANY_HULU) && !selectedNetwork.find(n => n === MEDIA_COMPANY_DISNEY)) {
      selectedNetwork = selectedNetwork.filter(n => n !== MEDIA_COMPANY_HULU)
    }
    if (selectedNetwork.find(n => n === MEDIA_COMPANY_AMAZON)) {
      selectedNetwork.push(MEDIA_COMPANY_MGM)
    } else if (selectedNetwork.find(n => n === MEDIA_COMPANY_MGM) && !selectedNetwork.find(n => n === MEDIA_COMPANY_AMAZON)) {
      selectedNetwork = selectedNetwork.filter(n => n !== MEDIA_COMPANY_MGM)
    }
    if (selectedNetwork.find(n => n === MEDIA_COMPANY_OTHERS)) {
      const allNetworks = [...new Set(details.map(e => e.labels).flat().filter(e => e.indexOf(MEDIA_COMPANY_COLON) > -1))]
      const otherNetworks = allNetworks.filter(company => !SOV_MEDIA_COMPANY_ALL_NETWORK.includes(company))
      otherNetworks.map(e => selectedNetwork.push(e))
    } else if (!selectedNetwork.find(n => n === MEDIA_COMPANY_OTHERS)) {
      const allNetworks = [...new Set(details.map(e => e.labels).flat().filter(e => e.indexOf(MEDIA_COMPANY_COLON) > -1))]
      const otherNetworks = allNetworks.filter(company => !SOV_MEDIA_COMPANY_ALL_NETWORK.includes(company))
      otherNetworks.forEach(e => {
        selectedNetwork = selectedNetwork.filter(n => n !== e)
      })
    }

    if (this.props.selectedNetwork === STREAMING) {
      details = details && selectedNetwork.length > 0 ? selectedNetwork.flatMap(network => details.filter(t => this.getNetworklabel(t.network).indexOf(network) > -1)) : details
      detailsByScore = detailsByScore && selectedNetwork.length > 0 ? selectedNetwork.flatMap(network => detailsByScore.filter(t => this.getNetworklabel(t.network).indexOf(network) > -1)) : detailsByScore
    } else {
      details = details && selectedNetwork.length > 0 ? selectedNetwork.flatMap(network => details.filter(t => this.getNetworklabel(t.labels).indexOf(network) > -1)) : details
      detailsByScore = detailsByScore && selectedNetwork.length > 0 ? selectedNetwork.flatMap(network => detailsByScore.filter(t => this.getNetworklabel(t.labels).indexOf(network) > -1)) : detailsByScore
    }
    details = this.state.searchText.length > 0 ? details.filter(e => e.name.toLowerCase().indexOf(this.state.searchText.toLowerCase()) > -1 || (e.display_name && e.display_name.toLowerCase().indexOf(this.state.searchText.toLowerCase()) > -1)) : details
    detailsByScore = this.state.searchText.length > 0 ? detailsByScore.filter(e => e.name.toLowerCase().indexOf(this.state.searchText.toLowerCase()) > -1 || (e.display_name && e.display_name.toLowerCase().indexOf(this.state.searchText.toLowerCase()) > -1)) : detailsByScore
    const rows = details.length > 0 ? details.filter(r => r.score >= 0.1) : []
    const rowsWithLessScore = detailsByScore.length > 0 ? detailsByScore.filter(r => r.score < 0.1) : []
    const score = rowsWithLessScore.length > 0 ? rowsWithLessScore.map(item => item.score).reduce((prev, next) => prev + next) : 0
    let uniqueRows = rows.reduce((unique, o) => {
      if (!unique.some(obj => obj.name === o.name)) {
        unique.push(o)
      }
      return unique
    }, [])
    uniqueRows = uniqueRows.length > 0 ? uniqueRows.sort((a, b) => b.score - a.score) : []
    const StyledTableCell = withStyles(() => ({
      head: {
        background: '#F4F5F6'
      }
    }))(TableCell)

    const networkCellStyle = (row) => {
      let network = ''
      if (this.props.selectedCategory === MEDIA_COMPANY) {
        network = row.labels.filter(l => l.indexOf(MEDIA_COMPANY_COLON) > -1)
        network = network.length > -1 ? network[0] : ''
      } else {
        network = !row.network && row.labels.indexOf(THEATRICAL_RELEASE) > -1 ? THEATRICAL_RELEASE : !row.network && row.labels.indexOf(MULTICHANNEL) > -1 ? MULTICHANNEL : this.getLabel(row.network, row.labels)
      }
      return { borderColor: SOVColors.getSOVColors(network) }
    }

    return (
      <>
        <span className="cardTitle">
          Content Rank on &nbsp;
          <span className='dateText'><Moment format='MMM DD'>{this.props.dateArray[this.props.dateIndex]}</Moment></span>
        </span>
        <p className='subTxt'>The top media content on the selected date</p>
        { (this.props.sovContentRank && this.props.sovContentRank.isFetching) &&
          <div className='loadingProgress'>
            <CircularProgress />
          </div>
        }
        { (this.props.sovContentRank && this.props.sovContentRank.details) &&
          <TableContainer className="mt-2 contentTable">
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <StyledTableCell className='notesTableSpace' width="5"></StyledTableCell>
                  <StyledTableCell className='notesTableSpace' width="10"></StyledTableCell>
                  <StyledTableCell className='notesTableSpace' width="15"></StyledTableCell>
                  <StyledTableCell>
                    <input type="text" name="name" placeholder="Title" className="nameInput" autoComplete="off" value={this.state.searchText} onChange={this.onSearchTextChange} ref={this.searchRef}/>
                  </StyledTableCell>
                  <StyledTableCell>Platform</StyledTableCell>
                  <StyledTableCell>SOV</StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {uniqueRows.map((row, index) => (
                  <TableRow key={row.entity_id}>
                    <TableCell className='cellBorder' style={networkCellStyle(row)}></TableCell>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>
                      <Thumbnail
                        entityOverrideImage={row.entity_override_image}
                        thumbnail={row.thumbnail}
                        name={row.display_name || row.name}
                        imageClass={'tableLogo'}
                        noImgTextClass={'sovContentRankNoImgText'}
                        noImgClass={'sovContentRankNoImg'}
                        divId={`sovContentRank_${index}`}
                        />
                    </TableCell>
                    <TableCell className='titleCell'>{row.display_name || row.name}</TableCell>
                    <TableCell>{this.getDisplayLabel(row.network, row.labels)}</TableCell>
                    <TableCell>{Math.round(row.score * 100) / 100}%</TableCell>
                  </TableRow>
                  ))}
                <TableRow>
                  <TableCell colSpan={6}><span className='moreResult'>{rowsWithLessScore.length} more results with a total share of conversation of {Math.round(score * 100) / 100}%</span></TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        }
      </>
    )
  }
}